import React,{useEffect} from 'react'
import { Card, NavLink } from 'react-bootstrap'
import { HashLink as Link } from 'react-router-hash-link';
import Maharaja021 from '../../images/maharaja/Maharaja021.jpg';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import RoomCard from './RoomCard';

import classicHome from '../../images/classic room converted/classicHome.jpg';
import comfortHome from '../../images/comfort room converted/comfortHome.jpg';
import economicHome from '../../images/economic room converted/economicHome.jpg';
import Aos from "aos";
import "aos/dist/aos.css";

import './RoomTypes.css';
import { NavItem, NavLinksViewMore } from '../Navbar/NavbarElements';


function RoomTypes() {

    useEffect(() => {
        Aos.init({duration:2000,disable:'mobile'});

      }, []);
    
    return (
        <div  >
            <Container id='rooms'  fluid  className='contShadow'>
                <h2 style={{textAlign:'center',padding:'20px 0 20px',color:'#976107'}}>Room Types</h2>
                <Row>
                    <Col data-aos='flip-up' lg={3} md={3} sm={3} className='ColCard' >
                        <RoomCard name={classicHome} title={'Classic Room'} dest={'/luxroom'} dest2="/luxroom" className='cardtof' />
                    </Col>
                    <Col data-aos='flip-up' lg={3} md={3} sm={3} className='ColCard' >
                        <RoomCard name={comfortHome} title={'Comfort Room'} dest='/deluxroom' dest2="/deluxroom" className='cardtof' />
                    </Col>
                    <Col data-aos='flip-up' lg={3} md={3} sm={3} className='ColCard' >
                        <RoomCard name={economicHome} title={'Economic Room'} dest='/premiumroom' dest2="/premiumroom" className='cardtof' />
                    </Col>
                    <Col data-aos='flip-up' lg={3} md={3} sm={3} className='ColCard' >
                        <RoomCard name={Maharaja021} title={'Maharaja Suite'} dest='/maharajasuite' dest2="/maharajasuite" className='cardtof' />
                    </Col>
                </Row>
                <Row>
                    <NavLinksViewMore to='/discover'>View More ...</NavLinksViewMore>
                    
                </Row>
                
            </Container>
            
        </div>
    )
}

export default RoomTypes
